// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --page-margin: var(--app-narrow-margin);
  --page-border-radius: var(--app-fair-radius);
  --page-actions-padding: 5px;
  --page-friends-gutter: calc(var(--page-margin) / 2);
  --page-pictures-gutter: calc(var(--page-margin) / 2);
}

.mirador-item .mirador-name {
  display: block;
  text-align: left;
  margin: var(--page-margin) 0px;
  font-size: 14px;
  padding-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mirador-item/styles/user-profile.page.scss"],"names":[],"mappings":"AAKA;EACE,uCAAA;EACA,4CAAA;EAEA,2BAAA;EACA,mDAAA;EACA,oDAAA;AALF;;AAWE;EACE,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AARJ","sourcesContent":["@import \"theme/mixins/scrollbars\";\r\n@import \"theme/mixins/inputs/select-alert\";\r\n\r\n// Custom variables\r\n// Note:  These ones were added by us and have nothing to do with Ionic CSS Custom Properties\r\n:host {\r\n  --page-margin: var(--app-narrow-margin);\r\n  --page-border-radius: var(--app-fair-radius);\r\n\r\n  --page-actions-padding: 5px;\r\n  --page-friends-gutter: calc(var(--page-margin) / 2);\r\n  --page-pictures-gutter: calc(var(--page-margin) / 2);\r\n}\r\n\r\n\r\n\r\n.mirador-item {\r\n  .mirador-name {\r\n    display: block;\r\n    text-align: left;\r\n    margin: var(--page-margin) 0px;\r\n    font-size: 14px;\r\n    padding-left: 4px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
